export const PROMOTE_CHANGES = 'promote-changes'
export const PUSH_TO_GIT = 'push-to-git'
export const MODEL_MANAGEMENT = 'model-management'
export const USER_MANAGEMENT = 'user-management'
export const USAGE_REPORT = 'usage-report'
export const IMPORT_EXPORT = 'import-export-data'
export const EXPORT_DATA = 'export-data'
export const TRACER_PREVIEW = 'tracer-preview'
export const TRACER_PREVIEW_MGMT = 'tracer-preview-mgmt'
export const DELETE_PROMOTED_FILES = 'delete-promoted-files'
export const CAN_CHANGE_ROLE = 'can-change-role'
